export default __webpack_public_path__ + "static/media/charizard.021fd99e.gif";